import React from "react";
import Particles from "react-particles-js"

import "./ParticlesComponent.scss";

const ParticlesComponent = props => {
    return <Particles
        params={{
            particles: {
                number: {
                    value: 1,
                    density: {
                        enable: true,
                        value_area: 20
                    }
                }
            }
        }} />
};

export default ParticlesComponent;